module.exports = __webpack_public_path__ + "assets/c3ce4b75f71b356ea1b50ab501f75690.png";